import { ref, computed } from 'vue';
import { FileManagerService } from '@/services/fileManagerService';
import { useDateFormatter } from './useDateFormatter';

export const useFileManager = () => {
  const { formatToISO } = useDateFormatter(ref(null));
  const filesData = ref([]);
  const currentPeriod = ref({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  });

  const fetchDates = async (type = 1) => {
    try {
      const firstDay = new Date(
        currentPeriod.value.year,
        currentPeriod.value.month - 1,
        1
      );
      
      const lastDay = new Date(
        currentPeriod.value.year,
        currentPeriod.value.month,
        0
      );

      const data = await FileManagerService.getDates(
        type,
        formatToISO(firstDay),
        formatToISO(lastDay)
      );
      
      filesData.value = data;
    } catch (error) {
      console.error("Error fetching dates:", error);
      throw error;
    }
  };

  const attributes = computed(() => {
    return filesData.value.map((file, index) => ({
      key: `event-${file.date}-${index}`,
      dates: new Date(file.date),
      dot: { color: "blue" },
      popover: {
        label: file.date,
        visibility: "hover",
      },
    }));
  });

  return {
    filesData,
    currentPeriod,
    fetchDates,
    attributes
  };
};